<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card v-if="orders" color="#58595b" offset="0" title="Orders">
          <div slot="header-actions">
            <v-btn
              v-if="formOpen"
              small
              raised
              color="info"
              @click="toggleForm()"
              >Close</v-btn
            >
          </div>
          <v-sheet v-if="formOpen" class="mt-2">
            <v-tabs
              v-model="activeTab"
              color="grey lighten-1"
              dark
              slider-color="black"
            >
              <v-tab ripple>Details</v-tab>
              <v-spacer></v-spacer>
              <v-btn :loading="saving" color="success" @click="save"
                >Save</v-btn
              >
              <!-- TAB : DETAILS -->
              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <v-form ref="ordersForm">
                      <v-layout key="form" wrap justify-center>
                        <v-flex xs6>
                          <v-text-field
                            v-model="formData.fullName"
                            label="Full Name of Orderer"
                            readonly
                          />
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-model="formData.phone"
                            label="Phone of Orderer"
                            readonly
                          />
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            v-model="formData.email"
                            label="Email of Orderer"
                            readonly
                          />
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-model="formData.status"
                            label="Payment Status"
                            readonly
                          />
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-model="formData.type"
                            label="Type"
                            readonly
                          />
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-model="formData.quantity"
                            label="Quantity"
                            readonly
                          />
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-model="formData.dateCreated"
                            label="Date of Order Rcvd"
                            readonly
                          />
                        </v-flex>
                        <v-flex xs12>
                          <v-textarea
                            v-model="formData.giftMessage"
                            label="Gift Message to be put on Card"
                            readonly
                          />
                        </v-flex>
                        <v-flex xs12>
                          <v-textarea
                            v-model="formData.specialRequests"
                            label="Special Requests from Order"
                            readonly
                          />
                        </v-flex>
                        <v-flex xs12>
                          <v-textarea
                            v-model="formData.adminNotes"
                            label="Admin Notes"
                          />
                        </v-flex>
                        <v-flex xs12>
                          <h3>Address Details of Recipient</h3>
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-model="formData.toFullName"
                            label="Full Name of Recipient"
                            readonly
                          />
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-model="formData.building"
                            label="Company/Building/Appt#"
                            readonly
                          />
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            v-model="formData.address"
                            label="Address of Recipient"
                            readonly
                          />
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-model="formData.suburb"
                            label="Suburb"
                            readonly
                          />
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-model="formData.postCode"
                            label="Post Code"
                            readonly
                          />
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-model="formData.city"
                            label="City"
                            readonly
                          />
                        </v-flex>
                        <v-flex xs6>
                          <v-select
                            v-model="formData.orderStatus"
                            label="UpstreamNZ Status (Change Manually)"
                            :items="[
                              'New',
                              'PaymentRcvd',
                              'Boxed Up',
                              'Delivered',
                            ]"
                          >
                          </v-select>
                        </v-flex>
                        <v-flex xs12>
                          <v-spacer></v-spacer>
                          <v-btn
                            block
                            :loading="saving"
                            color="success"
                            @click="save"
                            >Save</v-btn
                          >
                        </v-flex>
                      </v-layout>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-sheet>
          <v-data-table v-else :headers="headers" :items="orders" hide-actions>
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading font-weight-light text--darken-3"
                style="color: #4cc7e8"
                v-text="header.text"
              />
            </template>
            <template v-slot:items="props">
              <tr>
                <td class="text-xs">{{ props.item.id }}</td>
                <td class="text-xs">{{ props.item.dateCreated }}</td>
                <td class="text-xs">{{ props.item.fullName }}</td>
                <td class="text-xs">{{ props.item.phone }}</td>
                <td class="text-xs">{{ props.item.quantity }}</td>
                <td class="text-xs">{{ props.item.orderStatus }}</td>
                <td class="action-col" width="20">
                  <v-btn flat icon @click="open(props.item, props.item.id)">
                    <v-icon color="blue">mdi-folder-outline</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    data: () => ({
      formOpen: false,
      formData: {},
      saving: false,
      headers: [
        {
          sortable: true,
          text: "OrderID",
          value: "id",
        },
        {
          sortable: true,
          text: "Date Created",
          value: "dateCreated",
        },
        {
          sortable: true,
          text: "Full Name of Orderer",
          value: "fullName",
        },
        {
          sortable: true,
          text: "Phone",
          value: "phone",
        },
        {
          sortable: true,
          text: "Qty",
          value: "quantity",
        },
        {
          sortable: true,
          text: "UpstreamNZ Status",
          value: "orderStatus",
        },
        {
          sortable: false,
          text: "Actions",
          value: "actions",
        },
      ],
    }),
    computed: {
      ...mapGetters({
        user: "user",
        orders: "stripe/orders",
      }),
    },
    mounted() {
      this.$store.dispatch("stripe/loadOrders");
    },
    methods: {
      utcToLocal(date) {
        var convertdLocalTime = new Date(date);
        var hourOffset = convertdLocalTime.getTimezoneOffset() / 60;
        convertdLocalTime.setHours(convertdLocalTime.getHours() + hourOffset);
        return convertdLocalTime;
      },
      formatDate(date) {
        // return date.slice(0, 11);
      },
      open(order) {
        this.formData = order;
        this.formOpen = true;
      },
      toggleForm() {
        if (!this.formOpen) {
          this.formData = {};
        }
        this.formOpen = !this.formOpen;
      },
      save() {
        let payload = {
          id: this.formData.id,
          adminNotes: this.formData.adminNotes,
          orderStatus: this.formData.orderStatus,
        };
        this.saving = true;
        this.$store.dispatch("stripe/saveOrder", payload).then((result) => {
          this.saving = false;
          if (result.Result == "Success") {
            this.$swal("Success", "Order has been saved", "success");
          } else {
            this.$swal("Error", "Something went wrong.", "error");
          }
        });
      },
    },
  };
</script>


